<p-dialog header="{{drilldownReportInfo?.reportName}}" [(visible)]="drilldownReportInfo.visible" [modal]="true"
    [style]="{ width: '95%' }" [closable]="true" [draggable]="false" [resizable]="true" position="top"
    (onHide)="onDialogClose()">

    <!-- Export button in dialog header -->
    <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-center w-full">
            <span class="text-lg font-semibold">{{drilldownReportInfo?.reportName}} - {{drilldownReportInfo?.columnName}}</span>
            <div class="flex gap-2 menuMd popExportBtn mr-3">
                <p-menu [model]="exportMenuItems" [popup]="true" #exportMenu>
                    <ng-template let-item pTemplate="item">
                        <a href="#" (click)="exportReport(item.type)">
                            <!-- <i [class]="item.icon" class="mr-2"></i> --> 
                            <img [src]="'assets/images/'+item.image" />
                            {{ item.label }}
                        </a>
                    </ng-template>
                </p-menu>
                <p-button  severity="secondary"  (click)="exportMenu.toggle($event)" pTooltip="Export Report" tooltipPosition="bottom">
                    <img src="assets/images/share-icon.svg" alt="" />
                </p-button>
            </div>
        </div>
    </ng-template>
    <p-table *ngIf="isColumnInfoAvailable()" [value]="rows" [lazy]="true" [paginator]="true" [rows]="20"
        [totalRecords]="totalRecords" [first]="first" [loading]="false" (onLazyLoad)="loadData($event)"
        [scrollable]="true" scrollHeight="400px" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <!-- Add your table columns here -->
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let column of getUnifiedTableColumns(); let i = index">
                    {{column}}
                </th>
                <!-- Add more columns as needed -->
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
            <tr>
                <td *ngFor="let column of getUnifiedTableColumns(); let i = index" [attr.data-column-id]="column">
                    <a class="cursor-pointer" (click)="getJobDescription(row, column)"
                        *ngIf="isJobDescriptionColumn(column); else drilldownCellValue">Click Here</a>
                    <ng-template #drilldownCellValue>
                        <span [innerHTML]="getSafeHtml(getDisplayValue(row[i], column, row))"></span>
                    </ng-template>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="getUnifiedTableColumns().length || 1" class="text-center">No records found</td>
            </tr>
        </ng-template>
    </p-table>

    <!-- Loading message when data is not yet available -->
    <div *ngIf="!isColumnInfoAvailable()" class="text-center p-4">
        <p>Loading table configuration...</p>
    </div>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="showJobDescriptionPopup" [style]="{ width: '50rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" (onHide)="onJobDescriptionPopupHide()">
    <ng-template pTemplate="header">
        <h6>{{ jobCode }} - {{ currentJobTitle }}</h6>
    </ng-template>
    <ng-template pTemplate="body">
        <div [innerHTML]="currentJobDescription"></div>
        <b *ngIf="notesCreatedAt">{{ notesCreatedBy }} : </b>
        <span *ngIf="notesCreatedAt">{{ notesCreatedAt | date:'dd-MM-yyyy HH:mm' }}</span>
        <div>
            <b *ngIf="notesDescription">Note Description : </b>
            <span [innerHTML]="notesDescription"></span>
        </div>
    </ng-template>
</p-dialog>